export const getters = {
  // TODO replace state.menu with state.getters.getMenu
  getMenu(state) {
    return state.menu;
  },

  getAuth(state) {
    return state.authenticated;
  },
}